import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { HERO } from "@/constants/testIds";
import { Button } from "@/components/ui/button";

export default function Hero() {
  return (
    <section id="home" data-testid={HERO.root} className="relative border-b border-zinc-200">
      <div className="grid-bg absolute inset-0 pointer-events-none opacity-70" />
      <div className="relative px-6 md:px-12 lg:px-24 pt-16 md:pt-24 pb-16 md:pb-24 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 border border-zinc-300 px-3 py-1.5 mb-8">
            <span className="w-2 h-2 bg-[#FF5F1F]" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-700">
              Smart Wireless Water Automation • Since 2008
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter leading-[0.95] text-zinc-950">
            AUTOMATE <br className="hidden sm:block" />
            <span className="text-[#002FA7]">YOUR WATER.</span> <br className="hidden sm:block" />
            END THE OVERFLOW.
          </h1>

          <p className="mt-8 max-w-xl text-base sm:text-lg text-zinc-700 leading-relaxed">
            Aquamatic builds smart wireless water level controllers — Trigger, Macro, Matrix
            and Flexibell — that eliminate dry-runs, overflows and pump burnouts. Trusted by
            50,000+ homes, factories, high-rise societies, malls, hospitals and government
            buildings across India.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a href="#contact">
              <Button
                data-testid={HERO.ctaQuote}
                className="bg-[#002FA7] hover:bg-[#00227A] text-white rounded-none font-mono uppercase tracking-wider text-xs h-12 px-7"
              >
                Get a Free Quote <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </a>
            <a href="#products">
              <Button
                data-testid={HERO.ctaProducts}
                variant="outline"
                className="border-2 border-[#002FA7] text-[#002FA7] hover:bg-[#EFF6FF] rounded-none font-mono uppercase tracking-wider text-xs h-12 px-7"
              >
                Explore Products
              </Button>
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { k: "50,000+", v: "Customers Served" },
              { k: "5,000+", v: "Systems Installed" },
              { k: "16+ Yr", v: "Experience" },
            ].map((s) => (
              <div key={s.v} className="border-l-2 border-[#002FA7] pl-4">
                <div className="text-2xl sm:text-3xl font-bold tracking-tight">{s.k}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative border border-zinc-300 shadow-hard bg-white">
            <img
              src="https://images.unsplash.com/photo-1445140402314-ffd9630d0b19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwd2F0ZXIlMjB0YW5rJTIwZmFjdG9yeXxlbnwwfHx8fDE3ODMyNTcwMjN8MA&ixlib=rb-4.1.0&q=85"
              alt="Industrial water tank facility"
              className="w-full h-[420px] object-cover"
            />
            <div className="absolute bottom-4 left-4 bg-white border border-zinc-300 px-3 py-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-800">
              Model AX-Pro • Tank Sensor
            </div>
          </div>
          <div className="mt-4 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">
            <ShieldCheck className="w-4 h-4 text-[#002FA7]" />
            ISO 9001 • BIS Certified • CE Marked
          </div>
        </div>
      </div>
    </section>
  );
}
